import { Suspense, lazy, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Layout from '@/components/Layout';
import NotFoundPage from '@/pages/NotFoundPage';
import HomePage from '@/pages/HomePage';
import BlogPage from '@/pages/BlogPage';
import { ThemeProvider } from '@/components/ThemeProvider';
import { Loader2 } from 'lucide-react';

// Lazy-loaded: less-visited than the home/blog-index routes, so keep them
// out of the main bundle.
const BlogPostPage = lazy(() => import('@/pages/BlogPostPage'));
const DynamicPage = lazy(() => import('@/pages/DynamicPage'));

function RouteFallback() {
  return (
    <div className="flex justify-center py-16">
      <Loader2 className="w-6 h-6 animate-spin text-primary" />
    </div>
  );
}

function App({ notFound = false }: { notFound?: boolean }) {
  const { pathname } = useLocation();
  const [initialPath] = useState(pathname);
  return (
    <ThemeProvider>
      <Layout>
        <Suspense fallback={<RouteFallback />}>
          {notFound && pathname === initialPath ? <NotFoundPage /> : <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/:slug" element={<DynamicPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>}
        </Suspense>
      </Layout>
    </ThemeProvider>
  );
}

export default App;
